import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        navigate("/login", { replace: true });
        return;
      }
      const session_id = decodeURIComponent(match[1]);
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUser(data);
        // strip the hash and go to dashboard
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (err) {
        console.error("Auth exchange failed", err);
        navigate("/login", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[#050B14] text-white"
      data-testid="auth-callback-loading"
    >
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 rounded-full border-2 border-cyan-400 border-t-transparent animate-spin" />
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-cyan-400">
          Securing your flow...
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
